export type Permission = string;
export type PermissionGroup = Permission | Permission[];
export type PermissionInput = PermissionGroup[];
export type PermissionMode =
  | "any"
  | "all"
  | "anyCompleteGroup"
  | "anyInEachGroup";

export function checkPermissions(
  userPermissions: string[],
  permissions: PermissionInput,
  mode: PermissionMode,
): boolean {
  const userPermSet = new Set(userPermissions);

  // Normalize permissions: single permission -> group of one
  const groups = permissions.map((g) => (Array.isArray(g) ? g : [g]));

  switch (mode) {
    case "any": {
      // ANY: at least one match anywhere
      return groups.some((group) => group.some((p) => userPermSet.has(p)));
    }

    case "all": {
      // ALL: every group must be fully matched and non-empty
      return groups.every(
        (group) => group.length > 0 && group.every((p) => userPermSet.has(p)),
      );
    }

    case "anyCompleteGroup": {
      // ANY COMPLETE GROUP:
      // A group is valid if:
      // - non-empty
      // - all its permissions match
      return groups.some(
        (group) => group.length > 0 && group.every((p) => userPermSet.has(p)),
      );
    }

    case "anyInEachGroup": {
      // ANY IN EACH GROUP:
      // Every group must:
      // - be non-empty
      // - have at least one match
      return groups.every(
        (group) => group.length > 0 && group.some((p) => userPermSet.has(p)),
      );
    }

    default:
      return false;
  }
}
